import { Box } from '@mui/material';
import { CapabilityGrid } from './components/CapabilityGrid';
import { FinalCta } from './components/FinalCta';
import { LandingFooter } from './components/LandingFooter';
import { LandingHeader } from './components/LandingHeader';
import { LandingHero } from './components/LandingHero';
import { LandingMetrics } from './components/LandingMetrics';
import { StoryBand } from './components/StoryBand';

/** Composition root of the Flex marketing landing page. */
export function LandingPage() {
  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100vh' }}>
      <LandingHeader />
      <Box component="main">
        <LandingHero />
        <LandingMetrics />
        <CapabilityGrid />
        <StoryBand />
        <FinalCta />
      </Box>
      <LandingFooter />
    </Box>
  );
}
